import { createApp } from 'vue'
import axios from 'axios'

window.pawine = window.pawine || {}

const app = createApp({
  data() {
    return {
      isLoading: false,
      routes: window.pawine.routes || {},
      posts: [],
      totalPosts: 0,
      categories: window.pawine.categories || [],
      search: '',
      selectedCategory: null,
      pagination: {
        offset: 0,
        limit: 9,
      },
    }
  },
  computed: {
    currentPage() {
      return Math.ceil(this.pagination.offset / this.pagination.limit) + 1;
    },
    totalPages() {
      return Math.ceil(this.totalPosts / this.pagination.limit)
    }
  },
  mounted() {
    this.loadPosts()
  },
  watch: {
    search(newValue) {
      if (newValue == '') {
        this.loadPosts()
      }
    },
    selectedCategory() {
      this.pagination.offset = 0
      this.loadPosts()
    }
  },
  methods: {
    async loadPosts() {
      this.isLoading = true

      const resp = await axios.get(window.pawine.routes.loadPosts, {
        params: {
          offset: this.pagination.offset,
          category: this.selectedCategory,
          search: this.search,
        }
      })

      this.posts = resp.data.posts
      this.totalPosts = resp.data.totalPosts

      this.isLoading = false
    },
    setCategory(slug) {
      if (this.selectedCategory == slug) {
        this.selectedCategory = null
      } else {
        this.selectedCategory = slug
      }
    },
    searchPosts() {
      this.loadPosts()
    },
    loadPreviousPage() {
      if (this.pagination.offset > 0) {
        this.pagination.offset -= (this.pagination.limit)
        this.loadPosts()
      }
    },
    loadNextPage() {
      this.pagination.offset += (this.pagination.limit)
      this.loadPosts()
    },
  }
})

app.mount('#industry-news-index')
